import React from "react";
import { Box } from "@mui/material";
import { logoTokens } from "./tokens";

export default function LogoTagline({ children, tone = "light", fontSize, sx }) {
  const color = logoTokens.tagline.color[tone] ?? logoTokens.tagline.color.light;

  return (
    <Box
      component="span"
      sx={{
        fontFamily: logoTokens.fontStack,
        fontWeight: logoTokens.tagline.fontWeight,
        letterSpacing: logoTokens.tagline.letterSpacing,
        fontSize,
        lineHeight: 1.3,
        color,
        display: "block",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
